import styled from 'styled-components';

export const Contents = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`;

export const Tab = styled.div`
  box-sizing: border-box;
  display: flex;
  // height: 74px;
  width: 100%;
  padding: 0px 15px 20px 15px;
  background-color: #ffffff;
`;

export const Button = styled.button`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 34px;
  border: solid 1px #78818e;
  background-color: #ffffff;
  font-size: 13px;
  &.active {
    background-color: #78818e;
    color: #ffffff;
  }
`;

export const Table = styled.ul`
  display: flex;
  flex-direction: column;
  border: 1px solid #f2f2f2;
  overflow-x: scroll;
`;

export const TableHeader = styled.li`
  display: flex;
  align-items: center;
  height: 36px;
  width: 100%;
  border-bottom: 1px solid #f2f2f2;

  & > div {
    display: flex;
    justify-content: center;
    font-size: 11px;
  }

  .player {
    justify-content: flex-start !important;
    width: 100px;
    min-width: 100px;
    padding-left: 15px;
  }

  .row {
    width: 56px;
    min-width: 56px;
  }
`;

export const TableList = styled.li`
  display: flex;
  align-items: center;
  height: 36px;
  width: 100%;
  border-bottom: 1px solid #f2f2f2;

  &:last-child {
    border-bottom: none;
  }

  & > div {
    display: flex;
    justify-content: center;
    font-size: 13px;
  }

  .player {
    justify-content: flex-start !important;
    width: 100px;
    min-width: 100px;
    padding-left: 15px;
    white-space: normal;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .row {
    width: 56px;
    min-width: 56px;
    font-size: 13px;
    font-weight: 300;
  }
`;

export const Empty = styled.li`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 150px;
  border-bottom: none;
`;
